import React, { Component } from 'react';
import { observer } from "mobx-react";
import UserMetricsStore from 'Stores/Metrics/UserMetricsStore';
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    BarChart, Bar, Rectangle
} from "recharts";
import Helper from "Utils/Helper";

class GraphBar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (UserMetricsStore.dataLoading != false)
            return "";

        let webMetricUserDataSection = UserMetricsStore.data.dataSectionsByIds[this.props.sectionId];
        let valuesGroupsInfos = webMetricUserDataSection.valuesGroupsInfos;
        let data = webMetricUserDataSection.valuesWeb;
        let graphsWidth = UserMetricsStore.graphsWidth;

        return (
            <div className="smr-border Metrics-graph-container">

                <BarChart
                    width={graphsWidth}
                    height={500}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    {valuesGroupsInfos.map(it => {
                        let barColor = Helper.GetGraphColor(it.valueGroupIndex);
                        return (
                            <Bar
                                key={`bar_${it.fieldName}`}
                                name={it.title}
                                dataKey={it.fieldName}
                                fill={barColor}
                                activeBar={<Rectangle fill={barColor} stroke="blue" />}
                            />
                        );
                    })}
                </BarChart>

            </div>
        );
    }
}

export default observer(GraphBar);